<div class="ccl-select-wrapper">
  <div class="ccl-select-container" (click)="onContainerClick($event)" tabindex="0" role="button">
    <!-- Prefix Icon (left side) -->
    @if (showPrefixIcon) {
      <div class="ccl-select__prefix-icon" [class]="'ccl-select__prefix-icon--' + iconBackground">
        @if (prefixIcon) {
          <ng-container [ngTemplateOutlet]="prefixIcon"></ng-container>
        } @else {
          <span class="ccl-select__default-prefix-icon" aria-hidden="true">🔍</span>
        }
      </div>
    }

    <select
      [id]="id"
      class="ccl-select"
      [class.ccl-select--with-prefix]="showPrefixIcon"
      [disabled]="disabled"
      [multiple]="multiple"
      [size]="size"
      [attr.aria-invalid]="error"
      [attr.aria-describedby]="helperText ? id + '-help' : null"
      (change)="onSelectionChange($event)"
    >
      @for (option of options; track option.value) {
        <option
          [value]="option.value"
          [disabled]="option.disabled"
          [selected]="selectedValue === option.value"
        >
          {{ option.label }}
        </option>
      }
    </select>

    <!-- Custom Dropdown Icon (right side) - only when explicitly provided -->
    @if (filterIcon) {
      <div class="ccl-select__dropdown-icon">
        <ng-container [ngTemplateOutlet]="filterIcon"></ng-container>
      </div>
    }
  </div>

  @if (helperText) {
    <span [id]="id + '-help'" class="ccl-select__helper">
      {{ helperText }}
    </span>
  }

  @if (error) {
    <span class="ccl-select__error">
      {{ errorMessage }}
    </span>
  }
</div>
